import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
declare var $: any;
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl } from '@angular/forms';
import { AnpiService } from '../../../_services/anpi-code.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OwlDateTimeComponent } from 'ng-pick-datetime';
import * as moment from 'moment';
import { OwlDateTimeIntl } from 'ng-pick-datetime';
@Component({
  selector: 'app-reports',
  templateUrl: './cnss-reports.component.html',
  styleUrls: ['./cnss-reports.component.scss']
})

export class CnssReportsComponent implements OnInit {
  cnamgsForm: FormGroup;
  initiateReportForm: FormGroup;
  cnssForm: FormGroup;
  contactForm: FormGroup;
  reportList = true;
  lastsec = false;
  cnsstable = false;
  isSubmitted = false;
  id: any;
  page: any;
  response: any;
  title: any;
  public todayDate: any = new Date();
  Data: any;
  business: any;
  bank: any;
  employees: any;
  hasCnssForm: any;
  value: any;
  showAll: boolean = false;
  accountDetails: any;
  selectedBulkUploadYear: any;
  selectedBulkUploadQuarter: any;
  responsequarter: any;
  cnssReport: any;
  submitted = false;
  employerDetails: any;
  rejectReason: any;
  currentLang: any;
  penalty_details: any;
  reportId: any;
  cnamgsId: any;
  isResubmit = false;
  minReportDate: Date = new Date('2000-01-01');
  cnssCalculateResult: any;
  @ViewChild('dt46', { static: false }) dateTimePicker: OwlDateTimeComponent<Date>;
  cnamgsReport: any;
  CnamgsemployerDetails: any;

  isOpenCnamgsReport: boolean = true;
  isOpenCnssReport: boolean = true;
  cnamgspenalty_details: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private formBuilder: FormBuilder,
    private anpiService: AnpiService,
    private location: Location,
    private owlDateTimeIntl: OwlDateTimeIntl,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    // this.owlDateTimeIntl.isDisabledYear = (date) => {
    //   const year = date.year();
    //   return year < 2010;
    // };
    if (this.router.getCurrentNavigation().extras.state) {
      console.log(this.router.getCurrentNavigation().extras)
      this.value = this.router.getCurrentNavigation().extras.state.data;
      console.log("47", this.value)
      if (this.value == '1') {
        setTimeout(() => {
          $('#successModal').modal('show');
        }, 1000)
      } else if (this.value == '3') {
        setTimeout(() => {
          $('#reportModal').modal('show');
        }, 200)
      } else if (this.value == '4') {
        setTimeout(() => {
          $('#reportModal').modal('show');
        }, 200)
      }
    }
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      if (this.accountDetails.company_creation_date) {
        const companyDate = new Date(this.accountDetails.company_creation_date);
        if (!isNaN(companyDate.getTime())) {
          this.minReportDate = companyDate;
        }
      }
      console.log(this.minReportDate);
      this.resubmitForm();
      if (this.accountDetails.cnss != 1) {
        this.getAccountData();
      } else {
        this.checkLocalStorage();
      }
    }

    this.currentLang = localStorage.getItem('language') || "fr";
    console.log("104", this.currentLang)
  }

  ngOnInit() {
    console.log(this.anpiService.accountEvent)
    this.anpiService.accountEvent.subscribe(() => {
      console.log('inside employees emit event')
    });
    this.cnssForm = this.formBuilder.group({
      reportMonth: this.formBuilder.array(['']),
      confirm: ['', [Validators.requiredTrue]]
    });
    this.cnamgsForm = this.formBuilder.group({
      reportMonth: this.formBuilder.array(['']),
      confirm: ['', [Validators.requiredTrue]]
    });
    this.contactForm = this.formBuilder.group({
      year: ['', [Validators.required]],
      quarter: ['', [Validators.required]]
    });
    this.contactForm.controls['year'].setValue('2024');
    this.contactForm.controls['quarter'].setValue('1');
    this.initiateReportForm = this.formBuilder.group({
      initiate_report_year: ['', [Validators.required]],
      initiate_report_quarter: ['', [Validators.required]],

    });
    this.initiateReportForm.controls['initiate_report_year'].setValue('1');
    this.initiateReportForm.controls['initiate_report_quarter'].setValue('1');
    this.route.params.subscribe(
      (params: Params) => {
        console.log("28", params['id']);
        if (params['id'] != 'cnamgs') {
          this.id = params['id'];
          switch (this.id) {
            case 'normalcnss':
              {
                console.log('normalcnss')
                $('.payment_table').addClass('dNone');
                $('.dateTerminateInput').removeClass('dNone');
                $('.dateTerminate').removeClass('dBlock');
                $('.cnamgs_report').addClass('dNone');
                $('.employer_dash').addClass('dNone');
                $('.pendingStatus').removeClass('dBlock');
                $('.ongoingStatus').removeClass('dNone');
                $('.payNowStatus').addClass('dNone');
                $('.rejectedStatus').addClass('dNone');
                $('.completedStatus').addClass('dNone');
                $('input').removeClass('changeInput_style');
                $('.tableFooter').removeClass('dNone');
                $('#resubMit_btn').removeClass('d-block');
                $('#submit_btn').addClass('d-block');
                break;
              }
            case 'pendingcnss':
              {
                console.log('pendingcnss')
                $('.cnamgs_report').addClass('dNone');
                $('.employer_dash').addClass('dNone');
                $('.payment_table').addClass('dNone');
                //$('.dateTerminateInput').addClass('dNone');
                $('.dateTerminate').addClass('dBlock');

                $('.pendingStatus').addClass('dBlock');
                $('.ongoingStatus').addClass('dNone');
                $('.payNowStatus').addClass('dNone');
                $('.rejectedStatus').addClass('dNone');
                $('.completedStatus').addClass('dNone');
                $('input').addClass('changeInput_style');
                $('.tableFooter').addClass('dNone');
                break;
              }
            case 'payNowCnss':
              {
                console.log('payNowCnss')
                $('.cnamgs_report').addClass('dNone');
                $('.employer_dash').addClass('dNone');
                $('.payment_table').addClass('dInTable');
                $('.quarter_table').addClass('dNone');

                $('.pendingStatus').addClass('dNone');
                $('.ongoingStatus').addClass('dNone');
                $('.rejectedStatus').addClass('dNone');
                $('.payNowStatus').addClass('dBlock');
                $('.completedStatus').addClass('dNone');

                $('.tableFooter').addClass('dNone');
                $('.tableFooter2').addClass('d-block');
                $('.tableFooter3').addClass('dNone');
                break;
              }
            case 'completedCnss':
              {
                console.log('completedCnss')
                $('.cnamgs_report').addClass('dNone');
                $('.employer_dash').addClass('dNone');
                $('.payment_table').addClass('dInTable');
                $('.quarter_table').addClass('dNone');

                $('.pendingStatus').addClass('dNone');
                $('.ongoingStatus').addClass('dNone');
                $('.rejectedStatus').addClass('dNone');
                $('.payNowStatus').addClass('dNone');
                $('.completedStatus').addClass('dBlock');

                $('.tableFooter').addClass('dNone');
                $('.tableFooter2').addClass('dNone');
                $('.tableFooter3').addClass('d-block');
                break;
              }
            case 'rejectedCnss':
              {
                console.log('rejectedCnss')
                $('.cnamgs_report').addClass('dNone');
                $('.employer_dash').addClass('dNone');
                $('.payment_table').addClass('dBlock');
                $('.dateTerminateInput').removeClass('dNone');
                $('.dateTerminate').removeClass('dBlock');
                $('.quarter_table').addClass('dNone');

                $('.pendingStatus').addClass('dNone');
                $('.ongoingStatus').addClass('dNone');
                $('.payNowStatus').addClass('dNone');
                $('.rejectedStatus').addClass('dBlock');
                $('.completedStatus').addClass('dNone');


                $('.rejectedNote').addClass('d-block');
                $('input').removeClass('changeInput_style');
                $('.tableFooter').removeClass('dNone');
                break;
              }
            case 'resubmitCnss':
              {
                console.log('resubmitCnss')
                $('.cnamgs_report').addClass('dNone');
                $('.employer_dash').addClass('dNone');
                $('.payment_table').addClass('dBlock');
                $('.dateTerminateInput').removeClass('dNone');
                $('.dateTerminate').removeClass('dBlock');
                $('.quarter_table').addClass('dBlock');

                $('.pendingStatus').addClass('dNone');
                $('.ongoingStatus').addClass('dNone');
                $('.payNowStatus').addClass('dNone');
                $('.rejectedStatus').addClass('dBlock');
                $('.completedStatus').addClass('dNone');

                $('.rejectedNote').addClass('d-block');
                $('input').removeClass('changeInput_style');
                $('.tableFooter').removeClass('dNone');
                break;
              }
          }
        } else {
          this.page = params['id'];
          console.log("114", this.page)
        }
      }
    );
    // this.showCnssList();
    //this.getReports();
  }

  closeModal() {
    $('#reportModal').modal('hide');
    this.isSubmitted = false;
  }
  // onSubmitInitiateReport() {
  //   console.log("175")
  //   this.isSubmitted = true;
  //   if (this.initiateReportForm.invalid) {
  //     console.log("61", this.initiateReportForm)
  //     return;
  //   }
  //   var data = this.initiateReportForm.value;
  //   // this.ngxUiLoaderService.start();
  //   this.api.initiateReport(data).pipe(first())
  //     .subscribe(data => {
  //         // this.ngxUiLoaderService.stop();
  //         // this.response = data;
  //         if (this.response.status == 200) {
  //           // this.CompanyDetails = this.response.data;
  //         } else {
  //           // this.snackBar.open(res.message, "OK", {
  //           //      duration: 5000,
  //           //   });
  //         }
  //       },
  //       error => {
  //         // this.ngxUiLoaderService.stop();
  //       });
  //   this.isSubmitted = false;
  //   this.showCnssList();
  // }

  showCnssList() {
    console.log(this.contactForm.value)
    if (this.contactForm.invalid) {
      return;
    }
    var data = this.contactForm.value;
    console.log(data)
    this.ngxUiLoaderService.start();
    this.api.getCnssReportonQuarter(data).pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.responsequarter = res;
        if (this.responsequarter.status == 200) {
          this.cnssReport = this.responsequarter.results;
          this.employerDetails = this.responsequarter.employer;
          console.log("this.employerDetails", this.cnssReport);

          this.createMonthArray()
        } else {
          this.snackBar.open(this.responsequarter.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  onReportModalNext() {
    if (this.contactForm.invalid) {
      return;
    }

    if (this.value == '3') {
      // Existing behavior for value 3
      this.showDtsList();
    } else if (this.value == '4') {
      // New behavior for value 4 - bulk upload
      this.selectedBulkUploadYear = this.contactForm.get('year').value;
      this.selectedBulkUploadQuarter = this.contactForm.get('quarter').value;
      $('#reportModal').modal('hide');
      // Trigger file input programmatically
      setTimeout(() => {
        document.getElementById('bulkUploadReport').click();
      }, 300);
    }
  }

  showDtsList() {
    console.log(this.contactForm.value)
    if (this.contactForm.invalid) {
      return;
    }
    var data = this.contactForm.value;
    console.log(data)
    this.ngxUiLoaderService.start();
    this.api.getDtsReportonQuarter(data).pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.responsequarter = res;
        if (this.responsequarter.status == 200) {
          this.cnssReport = this.responsequarter.results.cnss.results;
          this.employerDetails = this.responsequarter.results.cnss.employer;

          this.cnamgsReport = this.responsequarter.results.cnamgs.results;
          this.CnamgsemployerDetails = this.responsequarter.results.cnamgs.employer;
          console.log("this.employerDetails", this.cnssReport);

          this.createMonthArray();
          this.createCnamgsMonthArray();
        } else {
          this.snackBar.open(this.responsequarter.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  onBulkUploadFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const filename = file.name;
      const ext = filename.split('.').pop().toLowerCase();

      // Validate file size (5MB limit)
      if (file.size > 5242880) {
        this.snackBar.open('File Size should be less than 5MB', "OK", {
          duration: 5000,
        });
        return;
      }

      // Validate file type
      if (ext != 'csv' && ext != 'xlsx' && ext != 'xls') {
        this.snackBar.open('File type not allowed. Allowed file types are .csv, .xlsx, .xls', "OK", {
          duration: 5000,
        });
        return;
      }

      // Create FormData and call API
      const formData = new FormData();
      formData.append('csvFile', file);
      formData.append('year', this.selectedBulkUploadYear);
      formData.append('quarter', this.selectedBulkUploadQuarter);
      formData['encrypt_mode'] = false;

      this.uploadBulkReport(formData);
    }
  }

  uploadBulkReport(formData: FormData) {
    console.log(formData);
    this.ngxUiLoaderService.start();
    this.api.combinedBulkUploadReport(formData).pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.responsequarter = res;
        if (this.responsequarter.status == 200) {
          // Handle success

          this.cnssReport = this.responsequarter.results.cnss.results;
          this.employerDetails = this.responsequarter.results.cnss.employer;

          this.cnamgsReport = this.responsequarter.results.cnamgs.results;
          this.CnamgsemployerDetails = this.responsequarter.results.cnamgs.employer;
          console.log("this.employerDetails", this.cnssReport);

          this.createMonthArray();
          this.createCnamgsMonthArray();
          // this.snackBar.open(this.response.message, "OK", {
          //   duration: 5000,
          // });
          // Reset form and file input
          this.contactForm.reset();
          const fileInput = document.getElementById('bulkUploadReport') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
        } else {
          this.location.back();
          this.snackBar.open(this.responsequarter.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
          this.snackBar.open('An error occurred during upload', "OK", {
            duration: 5000,
          });
        });
  }

  goToViewPage(val = null) {
    if (val) {
      this.value = '1';
    } else {
      $('#successModal').modal('hide');
      this.reportList = false;
      this.lastsec = true;
      this.cnsstable = false;
      this.router.navigate(['/cnss-reportList'], { state: { data: this.page } });
    }
  }

  paymentSubmit() {
    this.router.navigate(['/payment']);
  }

  get f() {
    return this.cnssForm.controls;
  }
  get r() {
    return this.cnssForm.controls.reportMonth as FormArray;
  }
  get fCnamgs() {
    return this.cnamgsForm.controls;
  }
  get rCnamgs() {
    return this.cnamgsForm.controls.reportMonth as FormArray;
  }

  async onSubmit() {
    console.log("361")
    this.submitted = true;

    // Collect form data from the shared table (using cnssForm)
    var sharedData = [];
    for (let key in this.cnssForm.controls.reportMonth['controls']) {
      this.cnssForm.controls.reportMonth['controls'][key]['controls'].reportEachemployee.updateValueAndValidity();
      sharedData.push(this.cnssForm.controls.reportMonth['controls'][key].value)
    }

    // Clone the same data for both CNSS and CNAMGS (since they use the same employee data)
    var cnssData = JSON.parse(JSON.stringify(sharedData));
    var cnamgsData = JSON.parse(JSON.stringify(sharedData));

    console.log("Shared Data:", sharedData)
    console.log("CNSS Data:", cnssData)
    console.log("CNAMGS Data:", cnamgsData)

    // Validate the form
    const isCnssInvalid = this.r.controls.some((control: AbstractControl) => control.invalid);

    // Check checkbox validation (using cnssForm.confirm as it's the one in the HTML)
    const confirmControl = this.cnssForm.get('confirm');
    if (isCnssInvalid || !confirmControl || !confirmControl.value) {
      console.log("CNSS Form:", this.cnssForm)
      // Mark confirm as touched to show error
      if (confirmControl) {
        confirmControl.markAsTouched();
        confirmControl.updateValueAndValidity();
      }
      return;
    }

    this.ngxUiLoaderService.start();
    let namedData = {
      cnss_report_data: cnssData,
      cnss_report_id: this.employerDetails.report_id,
      cnamgs_report_data: cnamgsData,
      cnamgs_report_id: this.CnamgsemployerDetails.cnamgs_report_id
    }
    console.log("Combined Data:", namedData)

    // return

    // Check if there's a combined submit endpoint, otherwise use individual endpoints
    if (this.api.submitDtsReport) {
      this.api.submitDtsReport(namedData).pipe(first())
        .subscribe(async data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            await this.dtsCalculate();
            // await this.cnamgsCalculate();

            console.log("383", this.response)
            console.log("384", this.employerDetails.uuid, this.CnamgsemployerDetails.uuid)

            this.router.navigate(['/cnss-report-view', this.employerDetails.uuid, this.CnamgsemployerDetails.uuid]);
          } else {
            this.snackBar.open(this.response.message, "OK", {
              duration: 5000,
            });
          }
        },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }

  }

  async dtsCalculate() {
    if (!this.employerDetails.report_id && !this.CnamgsemployerDetails.cnamgs_report_id) {
      this.snackBar.open("Report ID is required", "OK", {
        duration: 5000,
      });
      return;
    }
    const data = {
      cnss_report_id: this.employerDetails.report_id,
      cnamgs_report_id: this.CnamgsemployerDetails.cnamgs_report_id
    }
    const response = await this.api.dtsCalculate(data).pipe(first()).toPromise();
    if (response.status == 200) {
      this.cnssCalculateResult = response.result;
    } else {
      this.snackBar.open(response.message, "OK", {
        duration: 5000,
      });
    }
  }

  async cnssCalculate() {
    if (!this.employerDetails.report_id) {
      this.snackBar.open("Report ID is required", "OK", {
        duration: 5000,
      });
      return;
    }
    const data = {
      report_id: this.employerDetails.report_id
    }
    const response = await this.api.cnssCalculate(data).pipe(first()).toPromise();
    if (response.status == 200) {
      this.cnssCalculateResult = response.result;
    } else {
      this.snackBar.open(response.message, "OK", {
        duration: 5000,
      });
    }
  }

  // async cnamgsCalculate() {
  //   if (!this.CnamgsemployerDetails || (!this.CnamgsemployerDetails.cnamgs_report_id && !this.CnamgsemployerDetails.report_id)) {
  //     this.snackBar.open("CNAMGS Report ID is required", "OK", {
  //       duration: 5000,
  //     });
  //     return;
  //   }
  //   const data = {
  //     report_id: this.CnamgsemployerDetails.cnamgs_report_id || this.CnamgsemployerDetails.report_id
  //   };
  //   const response = await this.api.cnamgsCalculate(data).pipe(first()).toPromise();
  //   if (response.status == 200) {
  //     this.cnamgsCalculateResult = response.result;
  //   } else {
  //     this.snackBar.open(response.message, "OK", {
  //       duration: 5000,
  //     });
  //   }
  // }

  checkLocalStorage() {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      console.log("sadsadsad", this.accountDetails)
    }
    if (this.accountDetails.GNI == 1) {
      this.business = true;
    }
    if (this.accountDetails.BankDetails == 1) {
      this.bank = true;
    }
    if (this.accountDetails.EmployeeDetails == 1) {
      this.employees = true;
    }
    if (this.accountDetails.cnss != 1) {
      // console.log("65656666666666666")
      // this.anpiService.emitAccountEvent();
      // console.log("65656666666666666")
      this.anpiService.getAccountData();
    }
    console.log("142", this.value);
    if (this.value != "1") {
      console.log("sdfsdggsgsdgyuiaaswj")
      if (this.accountDetails.cnss == 1) {
        this.hasCnssForm = true;
      }
    }
    console.log("141", this.hasCnssForm);

    console.log("142", this.bank);
    if (this.accountDetails.GNI == '0') {
      this.title = 'business';
      console.log("138", this.title)
      setTimeout(function () {
        $('#initiateReportContainer').css('display', 'none');
      }, 100);
    } else if (this.business && this.accountDetails.BankDetails == '0') {
      this.title = 'bank';
      console.log("143", this.title)
      setTimeout(function () {
        $('#initiateReportContainer').css('display', 'none');
      }, 100);
    } else if (this.business && this.bank && this.accountDetails.cnss == '0' || this.business && this.bank && this.accountDetails.cnss == '2') {
      this.title = 'cnssForm';
      console.log("288", this.title)
      setTimeout(function () {
        $('#initiateReportContainer').css('display', 'none');
      }, 100);

    } else if (this.business && this.bank && this.accountDetails.cnss == '3') {
      this.title = 'cnssForm';
      console.log("288", this.title)
      setTimeout(function () {
        $('#initiateReportContainer').css('display', 'none');
      }, 100);

    } else if (this.accountDetails.cnss == '1') {
      this.title = 'initiateReport';
      console.log("341")
      setTimeout(function () {
        $('#initiateReportContainer').css('display', 'block');
        $('#report-header').css('display', 'block');
      }, 100);
    }
  }

  onSearchChange(e) {
    console.log(e.replace(' '))
    console.log(e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
  }

  goback(val) {
    console.log(val)
    if (val == 2) {
      this.id = null;
      this.location.back();
    } else if (val == 1) {
      console.log("468")
      this.location.back();
    } else {
      console.log("469")
      this.location.back();
    }
  }

  resubmitForm() {
    console.log("reportId:", this.accountDetails)
    this.route.params.subscribe(params => {
      console.log("471", params)
      this.reportId = params['id'];
      this.cnamgsId = params['cnamgsId'];
      console.log("528", this.reportId)
      console.log("CNAMGS ID:", this.cnamgsId)
      if (this.reportId && this.cnamgsId) {
        this.isResubmit = true;
        console.log('476 - DTS Edit Mode')
        this.getReportsbyIDDts();
      } else if (this.reportId) {
        this.isResubmit = true;
        console.log('476 - CNSS Edit Mode')
        this.getReportsbyIDDts();
      }
    });
    if ((this.value == null || this.value == '') && (this.reportId == null || this.reportId == '') &&
      this.accountDetails && this.accountDetails.EmployeeDetails == 1) {
      this.router.navigate(['/cnss-reportList'])
    }

  }

  getReportsbyID() {
    this.ngxUiLoaderService.start();
    this.api.getReportsbyID(this.reportId).pipe(first())
      .subscribe(data => {
        this.response = data;
        this.ngxUiLoaderService.stop();
        if (this.response.status == 200) {
          this.employerDetails = this.response.results.data;
          this.cnssReport = this.response.results.quarter;
          this.rejectReason = this.response.results.verification_history;
          this.penalty_details = this.response.results;
          console.log("152", this.cnssReport)
          console.log("153", this.employerDetails)
          console.log("154", this.employerDetails.employer_cnss)
          $('.rejectedNote').addClass('d-block');
          this.createMonthArray();
        } else {
          this.snackBar.open(data.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }


  getReportsbyIDDts() {
    this.ngxUiLoaderService.start();
    const data = {
      cnssuuid: this.reportId,
      cnamgsuuid: this.cnamgsId || null
    }
    this.api.getDtsReportsbyID(data).pipe(first())
      .subscribe(data => {
        this.response = data;
        this.ngxUiLoaderService.stop();
        if (this.response.status == 200) {
          // Assign CNSS data
          this.cnssReport = this.response.results.cnss.quarter;
          this.employerDetails = this.response.results.cnss.data;
          this.penalty_details = this.response.results.cnss;
          console.log("this.penalty_details", this.penalty_details);


          // Assign CNAMGS data
          this.cnamgsReport = this.response.results.cnamgs.quarter;
          this.CnamgsemployerDetails = this.response.results.cnamgs.data;
          this.cnamgspenalty_details = this.response.results.cnamgs;

          // Get verification history and penalty details (assuming they're at the root level)
          this.rejectReason = this.response.results.verification_history;
          // this.penalty_details = this.response.results;

          console.log("CNSS Report:", this.cnssReport)
          console.log("CNSS Employer Details:", this.employerDetails)
          console.log("CNAMGS Report:", this.cnamgsReport)
          console.log("CNAMGS Employer Details:", this.CnamgsemployerDetails)

          $('.rejectedNote').addClass('d-block');

          // Create form arrays for both CNSS and CNAMGS
          this.createMonthArray();
          this.createCnamgsMonthArray();
        } else {
          this.snackBar.open(data.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  createMonthArray() {
    console.log("506", this.cnssReport)
    for (let key in this.cnssReport) {
      var reportMonth = this.cnssForm.controls.reportMonth as FormArray;
      reportMonth.controls[key] = this.formBuilder.group({
        quarter: ['', []],
        reportEachemployee: this.formBuilder.array([''])
      })
      reportMonth.controls[key].controls.quarter.setValue(this.cnssReport[key].date)
      for (let key1 in this.cnssReport[key].employees) {
        var reportEachemployee = reportMonth.controls[key].controls.reportEachemployee as FormArray;
        reportEachemployee.controls[key1] = this.formBuilder.group({
          //termination_date: [''],
          working_hour: '',
          working_days: ['', [Validators.required, Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")]],
          ccpsid: '',
          cnss_salary: ['', [Validators.required, Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")]],
          cnamgs_salary: ['', [Validators.required, Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")]],
          family_allowances: ['',Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")],
          id: ''
        })
        reportEachemployee.controls[key1].get('working_hour').setValue(this.cnssReport[key].employees[key1].working_hour)
        reportEachemployee.controls[key1].get('working_days').setValue(this.cnssReport[key].employees[key1].working_days)
        reportEachemployee.controls[key1].get('family_allowances').setValue(this.cnssReport[key].employees[key1].family_allowances)
        // Convert cnss_salary to string without spaces for proper validation
        const cnssSalaryValue = this.cnssReport[key].employees[key1].cnss_salary;
        const cleanedCnssSalary = typeof cnssSalaryValue === 'string' ? cnssSalaryValue.replace(/\s/g, '') : cnssSalaryValue;
        reportEachemployee.controls[key1].get('cnss_salary').setValue(cleanedCnssSalary)
        // Convert cnamgs_salary to string without spaces for proper validation
        const cnamgsSalaryValue = this.cnssReport[key].employees[key1].cnamgs_salary;
        const cleanedCnamgsSalary = typeof cnamgsSalaryValue === 'string' ? cnamgsSalaryValue.replace(/\s/g, '') : cnamgsSalaryValue;
        reportEachemployee.controls[key1].get('cnamgs_salary').setValue(cleanedCnamgsSalary)
        reportEachemployee.controls[key1].get('ccpsid').setValue(this.cnssReport[key].employees[key1].ccpsid)
        reportEachemployee.controls[key1].get('id').setValue(this.cnssReport[key].employees[key1].id)
        console.log("530")
        //console.log(reportEachemployee.controls[key1].get('termination_date'))
        // .toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      }
    }
    console.log(this.cnssForm.controls.reportMonth)
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.reportList = false;
    this.lastsec = false;
    this.cnsstable = true;
    $('#reportModal').modal('hide');
    this.id = 'normalcnss';
    switch (this.id) {

      case 'normalcnss':
        {
          console.log('aa')
          $('.employer_dash').addClass('dNone');
          $('.cnamgs_report').addClass('dNone');
          $('.payment_table').addClass('dNone');
          $('.dateTerminateInput').removeClass('dNone');
          $('.dateTerminate').removeClass('dBlock');

          $('.pendingStatus').removeClass('dBlock');
          $('.ongoingStatus').removeClass('dNone');
          $('.payNowStatus').addClass('dNone');
          $('.completedStatus').addClass('dNone');

          $('input').removeClass('changeInput_style');
          $('.tableFooter').removeClass('dNone');
          $('#resubMit_btn').removeClass('d-block');
          $('#submit_btn').addClass('d-block');
          $('.rejectedStatus').addClass('dNone');
          break;
        }
    }
  }

  createCnamgsMonthArray() {
    console.log("createCnamgsMonthArray", this.cnamgsReport)
    if (!this.cnamgsReport) {
      return;
    }
    for (let key in this.cnamgsReport) {
      var reportMonth = this.cnamgsForm.controls.reportMonth as FormArray;
      reportMonth.controls[key] = this.formBuilder.group({
        quarter: ['', []],
        reportEachemployee: this.formBuilder.array([''])
      })
      reportMonth.controls[key].controls.quarter.setValue(this.cnamgsReport[key].date)
      for (let key1 in this.cnamgsReport[key].employees) {
        var reportEachemployee = reportMonth.controls[key].controls.reportEachemployee as FormArray;
        reportEachemployee.controls[key1] = this.formBuilder.group({
          //termination_date: [''],
          working_hour: '',
          working_days: ['', [Validators.required, Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")]],
          ccpsid: '',
          cnss_salary: ['', [Validators.required, Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")]],
          cnamgs_salary: ['', [Validators.required, Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")]],
          family_allowances: ['',Validators.pattern("^[0-9]+( [0-9]+)*(\.[0-9]+)?$")],
          id: ''
        })
        reportEachemployee.controls[key1].get('working_hour').setValue(this.cnamgsReport[key].employees[key1].working_hour)
        reportEachemployee.controls[key1].get('working_days').setValue(this.cnamgsReport[key].employees[key1].working_days)
        reportEachemployee.controls[key1].get('family_allowances').setValue(this.cnamgsReport[key].employees[key1].family_allowances)
        // Convert cnss_salary to string without spaces for proper validation
        const cnssSalaryValue = this.cnamgsReport[key].employees[key1].cnss_salary;
        const cleanedCnssSalary = typeof cnssSalaryValue === 'string' ? cnssSalaryValue.replace(/\s/g, '') : cnssSalaryValue;
        reportEachemployee.controls[key1].get('cnss_salary').setValue(cleanedCnssSalary)
        // Convert cnamgs_salary to string without spaces for proper validation
        const cnamgsSalaryValue = this.cnamgsReport[key].employees[key1].cnamgs_salary;
        const cleanedCnamgsSalary = typeof cnamgsSalaryValue === 'string' ? cnamgsSalaryValue.replace(/\s/g, '') : cnamgsSalaryValue;
        reportEachemployee.controls[key1].get('cnamgs_salary').setValue(cleanedCnamgsSalary)
        reportEachemployee.controls[key1].get('ccpsid').setValue(this.cnamgsReport[key].employees[key1].ccpsid)
        reportEachemployee.controls[key1].get('id').setValue(this.cnamgsReport[key].employees[key1].id)
        console.log("createCnamgsMonthArray - employee", key1)
      }
    }
    console.log(this.cnamgsForm.controls.reportMonth)
  }
  onResubmit() {
    console.log("570")
    this.submitted = true;
    var data = [];
    for (let key in this.cnssForm.controls.reportMonth['controls']) {
      this.cnssForm.controls.reportMonth['controls'][key]['controls'].reportEachemployee.updateValueAndValidity();
      data.push(this.cnssForm.controls.reportMonth['controls'][key].value)
    }
    console.log("577", data)
    if (this.cnssForm.invalid) {
      console.log(this.cnssForm)
      return;
    }
    let namedData = {
      report_data: data,
      report_id: this.reportId
    };
    this.ngxUiLoaderService.start();
    console.log("586", namedData)
    this.api.resubmitReport(namedData).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.response = data;
        if (this.response.status == 200) {
          //$('#successModal').modal('show');
          this.router.navigate(['/cnss-reportList'], { state: { resubmitData: this.response.result } });
        } else { }
        this.snackBar.open(this.response.message, "OK", {
          duration: 5000,
        });
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  closeGenrateReport() {
    $('#reportModal').modal('hide');
    this.location.back();
  }

  getAccountData() {
    console.log("442 get employer details")
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
        this.response = res.results;
        if (res.status == 200) {
          console.log("88", res)
          this.accountDetails = this.response;
          // this.accountDetails['BankDetails'] = 1;
          const data = JSON.stringify(this.accountDetails);
          localStorage.setItem('currentUserDetails', data);
          if (this.accountDetails.cnss == 1) {
            this.router.navigate(['/cnss-reportList']);
          }

        }
      },
        error => { });
  }
  view() {
    this.showAll = !this.showAll;
    if (this.showAll) {
      console.log("244", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir moins')
      } else {
        $("#view").text('View Less')
      }
    } else {
      console.log("252", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir plus')
      } else {
        $("#view").text('View More')
      }

    }
  }
  chosenYearHandler(e) {
    console.log(this.dateTimePicker);
    console.log(e);

    const initialDate = new Date(e);
    const extractedYear = initialDate.getFullYear();

    const minYear = this.minReportDate.getFullYear();
    const maxYear = this.todayDate.getFullYear();

    console.log(extractedYear);

    if (extractedYear >= minYear && extractedYear <= maxYear) {
      this.contactForm.controls['year'].setValue(extractedYear);
    } else {
      console.warn('Selected year is out of range');
    }

    if (this.dateTimePicker) {
      this.dateTimePicker.close();
    }
  }


  cnssReportExpand() {
    this.isOpenCnssReport = !this.isOpenCnssReport;
  }

  cnamgsReportExpand() {
    this.isOpenCnamgsReport = !this.isOpenCnamgsReport;
  }

}
